import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/site';

export default function SiteIntro() {
  const stats = [
    { label: '今日更新', value: '28+', icon: 'ri-flashlight-line' },
    { label: '收录资讯', value: '1,260', icon: 'ri-article-line' },
    { label: '专题合集', value: '36', icon: 'ri-stack-line' },
    { label: '日均阅读', value: '10万+', icon: 'ri-eye-line' },
  ];

  return (
    <section className="w-full px-4 md:px-8 pb-14 md:pb-16">
      <div className="rounded-lg bg-background-100 border border-background-200 p-6 md:p-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 items-center">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">{siteInfo.name}</h2>
            <p className="mt-2 text-primary-600 font-medium">{siteInfo.slogan}</p>
            <p className="mt-5 text-sm md:text-base text-foreground-600 leading-relaxed">{siteInfo.intro}</p>
            <Link
              to="/about"
              className="inline-flex items-center gap-1.5 mt-6 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              了解更多 <i className="ri-arrow-right-line" />
            </Link>
          </div>
          <div className="grid grid-cols-2 gap-4">
            {stats.map((s) => (
              <div key={s.label} className="rounded-lg bg-background-50 border border-background-200 p-5">
                <span className="w-9 h-9 flex items-center justify-center rounded-md bg-accent-100 text-accent-600 mb-3">
                  <i className={`${s.icon} text-lg`} />
                </span>
                <p className="font-heading text-2xl font-bold text-foreground-950">{s.value}</p>
                <p className="mt-1 text-xs text-foreground-500">{s.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}